module.exports = __webpack_public_path__ + "img/payment-disable-grey.88d561a5.svg";